import dayjs from 'dayjs';
import '@/shared/dayjs/export';

/**
 * Compute the end-of-day (23:59:59.999) LOCAL EST ms for the Eastern-local day two days before `now`.
 */
function computeEndOfDayTwoDaysAgoEst(now = new Date()): number {
  // Use dayjs to handle DST correctly by shifting to America/New_York
  const twoDaysAgo = dayjs(now).subtract(2, 'day').tz('America/New_York');
  const endOfDay = twoDaysAgo.endOf('day');
  return endOfDay.valueOf();
}

/**
 * Validate an incoming event timestamp. Returns true if timestamp is older than
 * end-of-day EST two days ago.
 */
export function isTimestampValidForChart(tsMs: number, now = new Date()): boolean {
  const cutoff = computeEndOfDayTwoDaysAgoEst(now);
  return tsMs <= cutoff;
}
